// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PhotosList-photoListBgImage-7UGjp {
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
    padding-top: 70%;
    border-radius: 6px;
}

.PhotosList-positionRelative-Xu1Ec {
    position: relative;
}

.PhotosList-displayGrid-P44QG {
    display: grid;
    grid-template-columns: 31% 31% 31%;
    grid-gap: 20px;
    margin-top: 30px;
}

.PhotosList-coverPhotoSection-_jEQz {
    color: var(--common-text-color);
    font-size: 14px;
    background-color: var(--primary-white-bg);
    display: inline-block;
    position: absolute;
    top: 8px;
    left: 8px;
    padding: 4px 9px;
    border-radius: 13px;
    text-align: center;
    font-weight: 500;
}

.PhotosList-tickIcon-brAvx {
    width: 11px;
    height: 8px;
    margin-right: 5px;
}

@media screen and (min-width:768px) and (max-width:1024px) {
    .PhotosList-displayGrid-P44QG {
        grid-template-columns: 100%;
    }
}

@media screen and (max-width: 767px) {
    .PhotosList-displayGrid-P44QG {
        grid-template-columns: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/PhotosList/PhotosList.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,yCAAyC;IACzC,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".photoListBgImage {\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 100%;\n    height: 100%;\n    padding-top: 70%;\n    border-radius: 6px;\n}\n\n.positionRelative {\n    position: relative;\n}\n\n.displayGrid {\n    display: grid;\n    grid-template-columns: 31% 31% 31%;\n    grid-gap: 20px;\n    margin-top: 30px;\n}\n\n.coverPhotoSection {\n    color: var(--common-text-color);\n    font-size: 14px;\n    background-color: var(--primary-white-bg);\n    display: inline-block;\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    padding: 4px 9px;\n    border-radius: 13px;\n    text-align: center;\n    font-weight: 500;\n}\n\n.tickIcon {\n    width: 11px;\n    height: 8px;\n    margin-right: 5px;\n}\n\n@media screen and (min-width:768px) and (max-width:1024px) {\n    .displayGrid {\n        grid-template-columns: 100%;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .displayGrid {\n        grid-template-columns: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"photoListBgImage": `PhotosList-photoListBgImage-7UGjp`,
	"positionRelative": `PhotosList-positionRelative-Xu1Ec`,
	"displayGrid": `PhotosList-displayGrid-P44QG`,
	"coverPhotoSection": `PhotosList-coverPhotoSection-_jEQz`,
	"tickIcon": `PhotosList-tickIcon-brAvx`
};
module.exports = ___CSS_LOADER_EXPORT___;
